import React from 'react';

import { STRUCTURE_TAB_ID_PREFIX, StructureTabKey } from './structureTabs';
import { KeepMountedTabPanel } from '../../../components/molecules/KeepMountedTabPanel';

export interface StructureTabSectionProps {
  tabKey: StructureTabKey;
  activeTab: StructureTabKey;
  /**
   * False in create mode and inside the job-creation modal, where the page has
   * no tab strip. The section then renders inline, as one item in the stacked
   * column, rather than as a panel nothing can bring to the front.
   */
  tabbed: boolean;
  /** False when the structure's type or the user's permissions exclude it. */
  visible: boolean;
  children: React.ReactNode;
}

/**
 * Renders one section of the structure detail page, as a tab panel when the
 * page is tabbed and inline when it is not.
 *
 * Without this the untabbed modes would break: `activeTab` would sit on
 * `details` with no strip to change it, and every other section would be
 * mounted-but-hidden forever.
 */
export const StructureTabSection: React.FC<StructureTabSectionProps> = ({
  tabKey,
  activeTab,
  tabbed,
  visible,
  children,
}) => {
  if (!visible) {
    return null;
  }

  if (!tabbed) {
    return <>{children}</>;
  }

  return (
    <KeepMountedTabPanel tabKey={tabKey} activeTab={activeTab} idPrefix={STRUCTURE_TAB_ID_PREFIX}>
      {children}
    </KeepMountedTabPanel>
  );
};
